import React from 'react';

export const CopyPasteIcon = ({
  width = '20',
  height = '20',
  color = '#98A2B3',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M3.33398 9.9987H2.66732C2.3137 9.9987 1.97456 9.85822 1.72451 9.60817C1.47446 9.35813 1.33398 9.01899 1.33398 8.66536V2.66536C1.33398 2.31174 1.47446 1.9726 1.72451 1.72256C1.97456 1.47251 2.3137 1.33203 2.66732 1.33203H8.66732C9.02094 1.33203 9.36008 1.47251 9.61013 1.72256C9.86018 1.9726 10.0007 2.31174 10.0007 2.66536V3.33203M7.33398 5.9987H13.334C14.0704 5.9987 14.6673 6.59565 14.6673 7.33203V13.332C14.6673 14.0684 14.0704 14.6654 13.334 14.6654H7.33398C6.5976 14.6654 6.00065 14.0684 6.00065 13.332V7.33203C6.00065 6.59565 6.5976 5.9987 7.33398 5.9987Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
